<template>
  <div class="d-inline-flex align-items-center justify-content-center my-2">
    <img src="@/assets/img/logos/logo.svg" class="h-72px" />
  </div>
</template>

<script>
export default {
  name: 'HeaderSurveyUser',
}
</script>
